// extracted by mini-css-extract-plugin
export var activityContainer = "_o1-0";
export var typingIndicatorContainer = "_o1-1";
export var typingIndicatorDot = "_o1-2";
export var wave = "_o1-3";